var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teenyicons:pin-solid",
    clipPath: "url(#clip0_2171_2856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.59961 10.3937C9.59961 9.75713 9.85247 9.14668 10.3026 8.6966C10.7526 8.24651 11.3631 7.99365 11.9996 7.99365C12.6361 7.99365 13.2466 8.24651 13.6967 8.6966C14.1468 9.14668 14.3996 9.75713 14.3996 10.3937C14.3996 11.0302 14.1468 11.6406 13.6967 12.0907C13.2466 12.5408 12.6361 12.7937 11.9996 12.7937C11.3631 12.7937 10.7526 12.5408 10.3026 12.0907C9.85247 11.6406 9.59961 11.0302 9.59961 10.3937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.59961 10.3936C1.60131 7.63646 2.69777 4.99282 4.64796 3.04383C6.59816 1.09483 9.24247 -5.22062e-07 11.9996 0C17.742 0 22.3996 4.6544 22.3996 10.3936C22.3996 14.672 20.2588 18.0624 17.9644 20.3536C16.9487 21.3706 15.8122 22.2594 14.5804 23C14.0652 23.304 13.5836 23.544 13.1644 23.7072C12.7692 23.864 12.3548 23.9856 11.9996 23.9856C11.6444 23.9856 11.23 23.864 10.8348 23.7072C10.3455 23.5078 9.87216 23.2714 9.41881 23C8.18698 22.2594 7.05052 21.3706 6.03481 20.3536C3.74041 18.0624 1.59961 14.672 1.59961 10.3936ZM11.9996 6.3952C10.9387 6.3952 9.92133 6.81663 9.17118 7.56677C8.42104 8.31692 7.99961 9.33433 7.99961 10.3952C7.99961 11.4561 8.42104 12.4735 9.17118 13.2236C9.92133 13.9738 10.9387 14.3952 11.9996 14.3952C13.0605 14.3952 14.0779 13.9738 14.828 13.2236C15.5782 12.4735 15.9996 11.4561 15.9996 10.3952C15.9996 9.33433 15.5782 8.31692 14.828 7.56677C14.0779 6.81663 13.0605 6.3952 11.9996 6.3952Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2171_2856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon_pin.f9478e5fcbc2da2564d2b7590f3f1667.svg";
export { ForwardRef as ReactComponent };